import React, { useState } from 'react';
import { handleDownloadFile }  from './gsc'; 
 

const PdfOrderProcessor = ({ selectedRowIds, apiRef }) => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Error handler for PDF operations
  const handleError = (errorMessage) => {
    setError(errorMessage);
    setLoading(false);
    setTimeout(() => setError(''), 5000); // Clear error after 5 seconds
  };

 

  // Function to process PDFs (replaces handlePdfOrdersClick)
  const processPdfs = async () => {
    try {
      setLoading(true);
      setError('');

      // Check if any rows are selected
      if (!selectedRowIds || selectedRowIds.length === 0) {
        handleError('Please select at least one row to generate PDF');
        return false;
      }

      console.log('Selected row IDs:', selectedRowIds);

      // Get the selected rows data
      const selectedRows = selectedRowIds.map((id) => apiRef.current.getRow(id));

      console.log('Selected rows data:', selectedRows);

      // Extract orderform paths from selected rows
      const orderFormPaths = selectedRows
        .map((row) => row.orderform)
        .filter((path) => path && path.trim() !== ''); // Remove empty/null paths

      console.log('Order form paths:', orderFormPaths);

      // Validate that we have valid PDF paths
      if (orderFormPaths.length === 0) {
        handleError('No valid order form PDFs found in selected rows');
        return false;
      }

      // Check for invalid PDF paths
      const invalidPaths = orderFormPaths.filter((path) => !path.match(/\.pdf$/i));
      if (invalidPaths.length > 0) {
        handleError(`Invalid PDF paths found: ${invalidPaths.join(', ')}`);
        return false;
      }

      console.log(`Processing ${orderFormPaths.length} PDF files`);

      // Handle single vs multiple PDFs
      let success;
      if (orderFormPaths.length === 1) {
        // Single PDF
        success = await handleDownloadFile(orderFormPaths[0], handleError);
        if (success) {
          console.log('Single PDF opened successfully');
        }
      } else {
        // Multiple PDFs - merge them
        success = await handleDownloadFile(orderFormPaths, handleError);
        if (success) {
          console.log(`${orderFormPaths.length} PDFs merged and opened successfully`);
        }
      }

      setLoading(false);
      return success;
    } catch (error) {
      console.error('Error in processPdfs:', error);
      handleError(`Failed to process PDFs: ${error.message}`);
      setLoading(false);
      return false;
    }
  };

  // Render error and loading UI
  const renderUi = () => (
    <>
      {/* Error display */}
      {error && (
        <div
          style={{
            color: '#d32f2f',
            backgroundColor: '#ffebee',
            padding: '12px',
            border: '1px solid #f44336',
            borderRadius: '4px',
            marginBottom: '10px',
            fontSize: '14px',
          }}
        >
          ❌ {error}
        </div>
      )}

      {/* Loading indicator */}
      {loading && (
        <div
          style={{
            color: '#1976d2',
            backgroundColor: '#e3f2fd',
            padding: '12px',
            border: '1px solid #2196f3',
            borderRadius: '4px',
            marginBottom: '10px',
            fontSize: '14px',
          }}
        >
          ⏳ Processing {selectedRowIds.length} PDF(s)...
        </div>
      )}
    </>
  );

  return {
    processPdfs,
    renderUi,
  };
};

export default PdfOrderProcessor;